/* 21.09.2026: linki z przedrostkiem jezyka (/it/products/...), inaczej wracaly na polska wersje */
var JAD_ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
/* jadore-dobor.js — dobór pielęgnacji (konsultacja online) + widok planu.
   Silnik: Supabase edge `beauty-plan` (create / finalize / get_plan).
   Konfiguracja: window.JDB_CFG {endpoint, anon, mode:'dobor'|'view', logged, email, metaPlanId, pageUrl} */
(function () {
  "use strict";
  var CFG = window.JDB_CFG || {};
  var root = document.getElementById("jdbRoot");
  if (!root) return;

  // 21.09.2026: ankieta na /en/ byla "czesc po polsku, czesc po angielsku". Napisy budowane
  // w JS biora sie z window.JDB_NAPISY (snippet jadore-dobor-napisy-js, tekst w jezyku strony);
  // polski literal zostaje jako zapas, gdyby snippetu nie bylo.
  var NAPISY = window.JDB_NAPISY || {};
  function T(k, pl) { var v = NAPISY[k]; return typeof v === "string" && v ? v : pl; }
  // Silnik `beauty-plan` dopasowuje odpowiedzi po POLSKICH nazwach (aliasy problemow, cele,
  // typ cery). Dlatego chip niesie w data-v kanoniczna polska wartosc, a wyswietla tlumaczenie;
  // do stanu i do backendu idzie data-v, do ekranu podsumowania - etykieta z mapy ponizej.
  function val(chip) { return (chip.dataset && chip.dataset.v) || chip.textContent.trim(); }
  var LABEL = {}, ZONE_LABEL = {};
  root.querySelectorAll(".chip[data-v]").forEach(function (c) { LABEL[c.dataset.v] = c.textContent.trim(); });
  root.querySelectorAll('[data-q="zones"][data-zone]').forEach(function (g) {
    var zl = g.previousElementSibling;
    if (zl && zl.classList.contains("zl")) ZONE_LABEL[g.dataset.zone] = zl.textContent.trim();
  });
  function label(v) { return LABEL[v] || v; }
  function zoneLabel(z) { return ZONE_LABEL[z] || z; }

  var state = {
    source: null, skin: null, age: null, zones: [], goals: [], uses: [], dislikes: [], routine: null,
    sun: null, sleepStress: null, pregnancyAnswer: null,
    priorities: [], prioDetail: {},
    sourceOther: "", skinOther: "", zonesOther: "", dislikesOther: "",
    whatMatters: "", currentProducts: "", treatments: "", sensitive: "", sensitiveOk: false, email: "",
    planId: null, plan: null, code: null, unlocked: false
  };
  window.jdbState = state;

  // Sesja zapisana przed dołożeniem ekranów priorytetów i ciąży nie ma tych pól —
  // wracamy do wartości domyślnych zamiast wywracać się na undefined.
  function normalizeState() {
    if (!Array.isArray(state.zones)) state.zones = [];
    if (!Array.isArray(state.priorities)) state.priorities = [];
    if (!state.prioDetail || typeof state.prioDetail !== "object") state.prioDetail = {};
    ["goals", "uses", "dislikes"].forEach(function (k) { if (!Array.isArray(state[k])) state[k] = []; });
  }

  // Kolejność ekranów pytań. "prio" bywa pomijany (klientka nie wskazała żadnej strefy),
  // dlatego licznik kroków liczy się z listy AKTUALNIE dostępnych ekranów, nie ze stałej —
  // inaczej „Krok 5 z 10" kłamałoby o jeden krok do końca formularza.
  var FLOW = [1, 2, 3, "prio", 4, 5, 6, 7, "preg", 8];
  // wartosci polskie (ida do backendu), etykiety w jezyku strony
  var SINCE = ["Od niedawna, do pół roku", "Od roku–dwóch", "Od lat"];
  var SINCE_LABEL = { "Od niedawna, do pół roku": T("od_niedawna", SINCE[0]), "Od roku–dwóch": T("od_roku_dwoch", SINCE[1]), "Od lat": T("od_lat", SINCE[2]) };
  var MAX_PRIO = 3;

  var current = 0;
  // Dopóki klientka nie przeszła ekranu stref, nie wiadomo, czy priorytety się pojawią.
  // Do tego czasu liczymy je do sumy kroków — inaczej licznik skoczyłby z „z 9" na „z 10"
  // w połowie formularza, czyli skłamałby dokładnie tam, gdzie miał nie kłamać.
  var zonesDecided = false;
  var bar = document.getElementById("jdbBar");
  function el(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? "" : s).replace(/[<>&"]/g, function (c) { return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]; }); }
  function money(p) { if (p == null || p === "") return ""; var n = Number(p); if (!isFinite(n)) return ""; return n.toFixed(2).replace(".", ",") + " zł"; }

  // ── priorytety: co w ogóle jest do uporządkowania ────────────────────────
  // Ten sam problem z dwóch stref (np. zaczerwienienia na nosie i policzkach) to JEDNA
  // pozycja — inaczej klientka zużyłaby dwa z trzech miejsc na to samo, a silnik i tak
  // dopasowuje problem po nazwie, nie po strefie.
  function prioOptions() {
    var out = [], seen = Object.create(null);
    (state.zones || []).forEach(function (z) {
      var c = String((z && z.concern) || "").trim();
      if (!c) return;
      if (!seen[c]) { seen[c] = { value: c, zones: [] }; out.push(seen[c]); }
      var zn = String((z && z.zone) || "").trim();
      if (zn && seen[c].zones.indexOf(zn) < 0) seen[c].zones.push(zn);
    });
    var other = String(state.zonesOther || "").trim();
    if (other && !seen[other]) out.push({ value: other, zones: [T("twoimi_slowami", "Twoimi słowami")] });
    return out;
  }
  function prioAvailable() { return prioOptions().length > 0; }

  function flow() {
    var out = [];
    for (var i = 0; i < FLOW.length; i++) {
      if (FLOW[i] === "prio" && !prioAvailable()) continue;
      out.push(FLOW[i]);
    }
    return out;
  }
  function flowTotal() {
    var n = flow().length;
    return (!zonesDecided && !prioAvailable()) ? n + 1 : n;
  }

  // ── bramka „Dalej" ───────────────────────────────────────────────────────
  // Ekran może mieć kilka grup chipów (np. skóra + wiek). Dalej odblokowują wyłącznie
  // grupy oznaczone data-req="1"; reszta jest dobrowolna.
  function refreshNext(screen) {
    if (!screen) return;
    var btn = screen.querySelector("[data-next]");
    if (!btn) return;
    if (screen.dataset.s === "prio") { btn.disabled = !(state.priorities || []).length; return; }
    var ok = true;
    screen.querySelectorAll('.chips[data-req="1"]').forEach(function (box) {
      var q = box.dataset.q;
      if (!q) return;
      var v = state[q];
      if (box.dataset.multi === "1" ? !(v && v.length) : !v) ok = false;
    });
    btn.disabled = !ok;
  }

  var jdbBooted = false;
  function show(n) {
    if (n === "prio") buildPrio();
    current = n;
    var f = flow(), idx = f.indexOf(n), active = null;
    root.querySelectorAll(".screen").forEach(function (s) {
      var on = s.dataset.s === String(n);
      s.classList.toggle("active", on);
      if (on) active = s;
    });
    var total = flowTotal();
    if (active) {
      var lbl = active.querySelector("[data-stepno]");
      if (lbl && idx >= 0) lbl.textContent = idx === f.length - 1 ? T("ostatni_krok", "Ostatni krok") : T("krok_x_z_y", "Krok {x} z {y}").replace("{x}", idx + 1).replace("{y}", total);
      refreshNext(active);
    }
    if (bar) {
      var pct = idx >= 0 ? ((idx + 1) / total * 100) : (n === 0 ? 0 : (n === "busy" ? 92 : 100));
      bar.style.width = pct + "%";
    }
    // scroll tylko w trakcie interakcji i gdy sekcja jest widoczna —
    // pierwszy render (init) nie może ściągać strony w dół (bug mobile)
    var canScroll = jdbBooted && root.offsetParent !== null;
    jdbBooted = true;
    if (!canScroll) return;
    var y = root.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }
  function busy(title, sub) {
    var t = el("jdbBusyT"), s = el("jdbBusyS");
    if (t) t.textContent = title || T("chwileczke", "Chwileczkę…");
    if (s) s.textContent = sub || "";
    show("busy");
  }

  // ── nawigacja ──
  window.jdbGo = function (n) { show(n); };
  window.jdbNext = function () {
    if (current === 3) zonesDecided = true;
    var f = flow(), i = f.indexOf(current);
    if (i < 0) { show(f[0]); return; }
    if (i >= f.length - 1) return;
    show(f[i + 1]);
  };
  window.jdbBack = function () {
    var f = flow(), i = f.indexOf(current);
    if (i <= 0) { show(0); return; }
    show(f[i - 1]);
  };
  window.jdbSkipZones = function () {
    zonesDecided = true;
    state.zones = []; state.zonesOther = "";
    state.priorities = []; state.prioDetail = {};
    root.querySelectorAll('[data-q="zones"] .chip').forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
    var zo = el("jdbZonesOther"); if (zo) zo.value = "";
    show(4);
  };

  // ── chipsy ──
  root.querySelectorAll(".chips").forEach(function (box) {
    var multi = box.dataset.multi === "1", q = box.dataset.q;
    if (!q) return;
    box.addEventListener("click", function (e) {
      var chip = e.target.closest(".chip"); if (!chip) return;
      var otherKey = chip.dataset.other;
      if (q === "zones") {
        var on = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", String(!on));
        state.zones = Array.prototype.slice.call(root.querySelectorAll('[data-q="zones"]')).reduce(function (acc, g) {
          g.querySelectorAll('[aria-pressed="true"]').forEach(function (c) { acc.push({ zone: g.dataset.zone, concern: val(c) }); });
          return acc;
        }, []);
        return;
      }
      if (multi) {
        var on2 = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", String(!on2));
        state[q] = Array.prototype.map.call(box.querySelectorAll('[aria-pressed="true"]'), function (c) { return val(c); });
      } else {
        box.querySelectorAll(".chip").forEach(function (c) {
          c.setAttribute("aria-pressed", "false");
          if (c.dataset.other) { var w = el("ow-" + c.dataset.other); if (w) w.classList.remove("on"); }
        });
        chip.setAttribute("aria-pressed", "true");
        state[q] = val(chip);
      }
      if (otherKey) { var w2 = el("ow-" + otherKey); if (w2) w2.classList.toggle("on", chip.getAttribute("aria-pressed") === "true"); }
      refreshNext(box.closest(".screen"));
    });
  });

  // ── ekran priorytetów ────────────────────────────────────────────────────
  // Lista powstaje dopiero przy wejściu na ekran, bo zależy od tego, co klientka
  // zaznaczyła na strefach. Wybór z poprzedniej wizyty zostaje tylko wtedy, gdy dana
  // pozycja nadal istnieje — po zmianie stref cofa się do stanu wyjściowego.
  function buildPrio() {
    var box = el("jdbPrioList");
    if (!box) return;
    normalizeState();
    var opts = prioOptions();
    var vals = opts.map(function (o) { return o.value; });
    state.priorities = state.priorities.filter(function (v) { return vals.indexOf(v) >= 0; });
    // Trzy problemy lub mniej — nie ma czego wybierać, zostaje potwierdzenie kolejności.
    if (!state.priorities.length && opts.length && opts.length <= MAX_PRIO) state.priorities = vals.slice(0, MAX_PRIO);
    box.innerHTML = opts.map(function (o) {
      var d = state.prioDetail[o.value] || {};
      return '<div class="prio-item" data-v="' + esc(o.value) + '">' +
        '<button type="button" class="prio-pick" aria-pressed="false">' +
          '<span class="prio-num" aria-hidden="true"></span>' +
          '<span class="prio-lbl">' + esc(label(o.value)) +
            (o.zones.length ? '<small class="prio-zone">' + esc(o.zones.map(zoneLabel).join(", ")) + "</small>" : "") +
          "</span>" +
        "</button>" +
        '<div class="prio-detail">' +
          '<p class="optlbl">' + esc(T("od_kiedy", "Od kiedy?")) + "</p>" +
          '<div class="chips prio-since">' + SINCE.map(function (s) {
            return '<span class="chip" role="button" data-v="' + esc(s) + '" aria-pressed="' + (d.since === s ? "true" : "false") + '">' + esc(SINCE_LABEL[s] || s) + "</span>";
          }).join("") + "</div>" +
          '<p class="optlbl">' + esc(T("co_juz_probowalas", "Co już próbowałaś?")) + " <span>" + esc(T("opcjonalnie", "(opcjonalnie)")) + "</span></p>" +
          '<input class="field prio-tried" placeholder="' + esc(T("np_krem_z_retinolem", "np. krem z retinolem, peelingi w salonie…")) + '" value="' + esc(d.tried || "") + '">' +
        "</div>" +
      "</div>";
    }).join("");
    syncPrio();
  }

  function syncPrio() {
    var box = el("jdbPrioList");
    if (!box) return;
    var pr = state.priorities || [];
    box.querySelectorAll(".prio-item").forEach(function (it) {
      var i = pr.indexOf(it.dataset.v), on = i >= 0;
      it.classList.toggle("picked", on);
      it.querySelector(".prio-pick").setAttribute("aria-pressed", String(on));
      it.querySelector(".prio-num").textContent = on ? String(i + 1) : "";
      it.querySelector(".prio-detail").classList.toggle("on", on);
    });
    var hint = el("jdbPrioHint");
    if (hint) {
      hint.textContent = pr.length >= MAX_PRIO
        ? T("masz_komplet_trzech", "Masz komplet trzech. Chcesz zmienić kolejność — odznacz jedną i wskaż inną.")
        : T("wskaz_od_jednej_do_trzech", "Wskaż od jednej do trzech rzeczy — kolejność klikania to kolejność ważności.");
    }
    refreshNext(root.querySelector('.screen[data-s="prio"]'));
  }

  (function bindPrio() {
    var box = el("jdbPrioList");
    if (!box) return;
    var detailFor = function (v) { return state.prioDetail[v] || (state.prioDetail[v] = {}); };
    box.addEventListener("click", function (e) {
      var item = e.target.closest(".prio-item"); if (!item) return;
      var since = e.target.closest(".prio-since .chip");
      if (since) {
        since.parentElement.querySelectorAll(".chip").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        since.setAttribute("aria-pressed", "true");
        detailFor(item.dataset.v).since = val(since);
        return;
      }
      if (!e.target.closest(".prio-pick")) return;
      var v = item.dataset.v, pr = state.priorities;
      var i = pr.indexOf(v);
      if (i >= 0) pr.splice(i, 1);
      else if (pr.length >= MAX_PRIO) {
        var h = el("jdbPrioHint");
        if (h) { h.classList.add("nudge"); setTimeout(function () { h.classList.remove("nudge"); }, 700); }
        return;
      } else pr.push(v);
      syncPrio();
    });
    box.addEventListener("input", function (e) {
      var f = e.target.closest(".prio-tried"); if (!f) return;
      var item = e.target.closest(".prio-item"); if (!item) return;
      detailFor(item.dataset.v).tried = f.value;
    });
  })();

  // Ciąża i karmienie: brak odpowiedzi i „Wolę nie odpowiadać" traktujemy jak „tak" —
  // silnik przy pregnancy:true blokuje retinol, kwas salicylowy i hydrochinon.
  function pregnancyFlag() { return state.pregnancyAnswer !== "Nie"; }
  function prioritiesDetail() {
    return (state.priorities || []).map(function (v) {
      var d = (state.prioDetail || {})[v] || {};
      return { concern: v, since: d.since || "", tried: String(d.tried || "").trim() };
    });
  }

  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  window.jdbCheckPlanGate = function () {
    var need = (state.sensitive || "").trim().length > 0;
    var lab = el("jdbSensConsent"), btn = el("jdbPlanBtn");
    if (lab) lab.style.display = need ? "flex" : "none";
    var sensitiveOk = !(need && !state.sensitiveOk);
    var emailOk = EMAIL_RE.test((state.email || "").trim());
    var mk = el("jdbMkacc"), rg = el("jdbReg");
    // dla zalogowanej klientki (mk/rg nie istnieją w DOM) zgody nie są wymagane
    var consentOk = (!mk && !rg) || (mk && mk.checked && rg && rg.checked);
    if (btn) btn.disabled = !(sensitiveOk && emailOk && consentOk);
  };

  // ── stan między nawigacjami (rejestracja konta = przeładowanie strony) ──
  function saveLocal() {
    try {
      localStorage.setItem("jdb_plan_id", state.planId || "");
      var copy = {}; for (var k in state) if (k !== "plan") copy[k] = state[k];
      localStorage.setItem("jdb_state", JSON.stringify(copy));
    } catch (e) { /* prywatny tryb */ }
  }
  function loadLocal() {
    try {
      var pid = localStorage.getItem("jdb_plan_id") || "";
      var st = JSON.parse(localStorage.getItem("jdb_state") || "null");
      if (st) for (var k in st) if (k in state) state[k] = st[k];
      if (pid) state.planId = pid;
    } catch (e) { /* ignore */ }
    normalizeState();
  }

  // ── API ──
  function api(body) {
    return fetch(CFG.endpoint, {
      method: "POST",
      headers: { "Authorization": "Bearer " + CFG.anon, "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ── krok „Przygotuj mój plan" ──
  window.jdbPrepPlan = function () {
    normalizeState();
    var profile = {
      source: state.source, source_other: state.sourceOther,
      skin: state.skin, skin_other: state.skinOther,
      zones: state.zones, zones_other: state.zonesOther,
      goals: state.goals, uses: state.uses,
      dislikes: state.dislikes, dislikes_other: state.dislikesOther,
      routine: state.routine,
      what_matters: state.whatMatters, current_products: state.currentProducts,
      treatments_done: state.treatments,
      sensitive_text: state.sensitive, sensitive_consent: !!state.sensitiveOk,
      consent_version: "v1",
      // ── pola ekranów dołożonych 28.08.2026 (silnik dwuetapowy) ──
      priorities: state.priorities,
      priorities_detail: prioritiesDetail(),
      pregnancy: pregnancyFlag(),
      age: state.age,
      sun: state.sun,
      sleep_stress: state.sleepStress,
      lang: CFG.lang || "pl"
    };
    busy(T("przygotowujemy_twoj_plan", "Przygotowujemy Twój plan…"), T("specjalistka_dobiera", "Nasza specjalistka dobiera produkty i wskazówki pod Twoje odpowiedzi."));
    var mail = (state.email || "").trim().toLowerCase();
    api({ profile: profile, save: true, website: "", email: (/^\S+@\S+\.\S+$/.test(mail) ? mail : null) }).then(function (r) {
      if (!r || !r.success || !r.plan) throw new Error((r && r.error) || "bez planu");
      state.planId = r.plan_id; state.plan = r.plan; state.unlocked = false;
      saveLocal();
      renderTeaser(r.plan);
      show(9);
    }).catch(function () {
      busy(T("cos_przerwalo", "Coś przerwało połączenie…"), T("odswiez_odpowiedzi_zachowane", "Odśwież stronę i spróbuj ponownie — Twoje odpowiedzi zachowałyśmy."));
      saveLocal();
    });
  };

  // ── render: teaser (przed dołączeniem — bez cen) ──
  function productCard(p, withPrice, brandChip) {
    var img = p.image_url ? '<span class="ri"><img loading="lazy" src="' + esc(p.image_url) + '" alt=""></span>' : '<span class="ri"></span>';
    var right = withPrice && p.price != null ? '<span class="rprice">' + money(p.price) + "</span>"
      : (brandChip ? '<span class="brandchip">' + esc(p.vendor || "") + "</span>" : "");
    var inner = img +
      '<span style="flex:1;min-width:0"><span class="rn" style="display:block">' + esc(p.title) + "</span>" +
      (p.vendor ? '<span class="rd" style="display:block">' + esc(p.vendor) + "</span>" : "") +
      (p.why ? '<span class="why" style="display:block">' + esc(p.why) + "</span>" : "");
    // bez cen (teaser) nie linkujemy do sklepu — PDP i tak nie pokaże ceny, to myli;
    // zamiast tego kierunek: załóż konto → pełny plan
    if (!withPrice) {
      return '<span class="rec" style="cursor:default">' + inner +
        '<span class="see" style="display:block">' + esc(T("pelny_plan_i_cena_po_dolaczeniu", "Pełny plan i cena — po dołączeniu ↓")) + "</span></span>" + right + "</span>";
    }
    return '<a class="rec" href="' + JAD_ROOT + 'products/' + esc(p.handle) + '">' + inner +
      '<span class="see" style="display:block">' + esc(T("zobacz_w_sklepie", "Zobacz w sklepie →")) + "</span></span>" + right + "</a>";
  }

  function renderTeaser(plan) {
    el("jdbIntro").textContent = plan.intro || T("przygotowalysmy_twoj_plan", "Przygotowałyśmy Twój plan pielęgnacji.");
    var m = el("jdbMatter");
    if ((state.whatMatters || "").trim()) { m.innerHTML = "<b>" + esc(T("napisalas_ze_zalezy_ci", "Napisałaś, że zależy Ci na:")) + "</b> „" + esc(state.whatMatters.trim()) + "” " + esc(T("plan_ukladamy_wokol_tego", "— plan układamy wokół tego.")); m.style.display = "block"; }
    else m.style.display = "none";
    var iss = el("jdbIssues");
    if (plan.issues && plan.issues.length) { iss.innerHTML = plan.issues.map(esc).join("<br>"); iss.style.display = "block"; }
    else iss.style.display = "none";
    el("jdbEstLbl").textContent = T("na_poczatek_najwazniejszy_krok", "Na początek — najważniejszy krok");
    var first = (plan.products || [])[0];
    el("jdbEst").innerHTML = first ? productCard(first, false, true) : "";
    el("jdbLockbox").style.display = "block";
    var cta = el("jdbUnlockCta");
    cta.style.display = "block";
    cta.textContent = CFG.logged ? T("przypisz_plan_do_konta", "Przypisz plan do mojego konta — odbierz pełny plan") : T("zaloz_konto_odbierz_plan", "Załóż konto — odbierz pełny plan i −5%");
    el("jdbFullPlan").style.display = "none";
    el("jdbPlanCode").style.display = "none";
  }

  // ── render: pełny plan (po dołączeniu — z cenami) ──
  function renderFull(plan, code) {
    el("jdbIntro").textContent = plan.intro || T("twoj_plan_pielegnacji", "Twój plan pielęgnacji.");
    el("jdbMatter").style.display = "none";
    var iss = el("jdbIssues");
    if (plan.issues && plan.issues.length) { iss.innerHTML = plan.issues.map(esc).join("<br>"); iss.style.display = "block"; } else iss.style.display = "none";
    el("jdbEstLbl").textContent = "Dobrane dla Ciebie";
    var prods = plan.products || [];
    var core = prods.filter(function (p) { return (p.vendor || "") === "estGen"; });
    if (!core.length) core = prods.slice(0, 3);
    var alts = prods.filter(function (p) { return core.indexOf(p) === -1; });
    el("jdbEst").innerHTML = core.map(function (p) { return productCard(p, true, false); }).join("");
    el("jdbLockbox").style.display = "none";
    el("jdbUnlockCta").style.display = "none";
    el("jdbFullPlan").style.display = "block";
    // plan AM/PM
    function olify(list) {
      return "<ol>" + (list || []).map(function (s) {
        return "<li>" + esc(s.step || "") + (s.note ? "<small>" + esc(s.note) + "</small>" : "") + "</li>";
      }).join("") + "</ol>";
    }
    el("jdbPlan").innerHTML =
      '<div><p class="ph">Rano</p>' + olify(plan.plan_am) + "</div>" +
      '<div><p class="ph">Wieczorem</p>' + olify(plan.plan_pm) + "</div>" +
      ((plan.weekly && plan.weekly.length) ? '<div><p class="ph">W tygodniu</p>' + olify(plan.weekly) + "</div>" : "");
    // składniki
    function ulify(a) { return "<ul>" + (a || []).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>"; }
    el("jdbIng").innerHTML =
      '<div class="seek"><p class="ih">' + esc(T("szukaj", "Szukaj")) + "</p>" + ulify(plan.ingredients_seek) + "</div>" +
      '<div class="avoid"><p class="ih">' + esc(T("ostroznie_z", "Ostrożnie z")) + "</p>" + ulify(plan.ingredients_avoid) + "</div>";
    // rytm dnia + oczekiwania — sekcje opcjonalne (starsze plany ich nie mają)
    var lw = el("jdbLifeWrap");
    if (lw) {
      if (plan.lifestyle && plan.lifestyle.length) {
        el("jdbLife").innerHTML = plan.lifestyle.map(function (x) {
          return '<div class="treat"><div class="ti">✦</div><div><p class="td">' + esc(x) + "</p></div></div>";
        }).join("");
        lw.style.display = "";
      } else lw.style.display = "none";
    }
    var ew = el("jdbExpectWrap");
    if (ew) {
      if (plan.expectations) { el("jdbExpect").textContent = plan.expectations; ew.style.display = ""; }
      else ew.style.display = "none";
    }
    // zabiegi
    el("jdbTreat").innerHTML = (plan.treatments || []).map(function (t) {
      return '<div class="treat"><div class="ti">✦</div><div><p class="tn">' + esc(t.name) + '</p><p class="td">' + esc(t.why || "") + "</p></div></div>";
    }).join("") || '<p class="rd" style="padding:8px 0">' + esc(T("zabiegi_dobierzemy_na_wizycie", "Zabiegi dobierzemy wspólnie na wizycie.")) + "</p>";
    // alternatywy
    el("jdbAlt").innerHTML = alts.length ? alts.map(function (p) { return productCard(p, true, true); }).join("")
      : '<p class="rd" style="padding:8px 0">' + esc(T("trzon_planu_pokrywa", "Trzon planu w pełni pokrywa Twoje potrzeby.")) + "</p>";
    // recap
    var chipsSrc = [].concat(state.skin || [], state.goals || [], (state.zones || []).map(function (z) { return label(z.concern) + " (" + zoneLabel(z.zone) + ")"; }), state.dislikes || []).map(label);
    var rec = el("jdbRecap");
    if (chipsSrc.length) { rec.innerHTML = chipsSrc.slice(0, 12).map(function (c) { return '<span class="rc">' + esc(c) + "</span>"; }).join(""); rec.parentElement.parentElement.style.display = ""; }
    else rec.parentElement.parentElement.style.display = "none";
    // kod
    var pc = el("jdbPlanCode");
    if (code) { el("jdbCode2").textContent = code; pc.style.display = "flex"; } else pc.style.display = "none";
  }

  window.jdbUnlock = function () {
    if (state.plan) { renderFull(state.plan, state.code); show(9); }
  };

  // ── dołączenie: konto → finalize ──
  window.jdbToAccount = function () {
    saveLocal();
    if (CFG.logged && CFG.email) { finalizeFlow(); return; }
    // zgody i e-mail zebrane już na ekranie 8 — nie zatrzymujemy się na ekranie 10,
    // od razu otwieramy logowanie Shopify (ekran 10 zostaje tylko jako fallback UI
    // pod przyciskiem, na wypadek popup-blockera obsłużonego w jdbGoLogin()).
    show(10);
    jdbGoLogin();
  };
  function finalizeFlow() {
    var pid = state.planId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
    if (!pid) { show(0); return; }
    busy(T("przypisujemy_plan_do_konta", "Przypisujemy plan do Twojego konta…"), T("zapisujemy_dobor_w_karcie", "Zapisujemy dobór w Twojej karcie Klientki."));
    api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (r) {
      if (!r || !r.success) throw new Error((r && r.error) || "finalize");
      state.plan = r.plan || state.plan; state.code = r.discount_code || null; state.unlocked = true; state.planId = pid;
      saveLocal();
      var codeEl = el("jdbCode"); if (codeEl) codeEl.textContent = state.code || "—";
      var cbox = el("jdbCodeBox"); if (cbox) cbox.style.display = state.code ? "flex" : "none";
      var rep = el("jdbRepeat"); if (rep) rep.style.display = r.repeat ? "block" : "none";
      var mailNote = el("jdbMailNote"); if (mailNote) mailNote.style.display = r.mailed ? "block" : "none";
      var fp = el("jdbSuccessProd");
      var first = ((r.plan || {}).products || [])[0];
      if (fp && first) {
        fp.innerHTML = '<div class="img">' + (first.image_url ? '<img src="' + esc(first.image_url) + '" alt="">' : "") + "</div>" +
          '<div><p class="name">' + esc(first.title) + '</p><div class="cat">' + esc(first.vendor || "") + "</div>" +
          '<span class="price-live">' + money(first.price) + "</span></div>";
      }
      show(12);
    }).catch(function () {
      busy(T("nie_udalo_sie_przypisac", "Nie udało się przypisać planu…"), T("odswiez_sprobujemy_ponownie", "Odśwież stronę — spróbujemy ponownie. Plan jest bezpiecznie zapisany."));
    });
  }

  // ── widok „Mój plan" ──
  function viewFlow(pid) {
    busy(T("otwieramy_twoj_plan", "Otwieramy Twój plan…"), "");
    api({ action: "get_plan", plan_id: pid, website: "" }).then(function (r) {
      if (!r || !r.success || !r.plan) throw new Error("brak");
      state.plan = r.plan; state.code = r.discount_code; state.planId = pid;
      if (r.status === "active") { renderFull(r.plan, r.discount_code); show(9); }
      else if (CFG.logged && CFG.email) {
        // zalogowana klientka ze szkicem planu (rejestracja poza flow doboru) —
        // dokańczamy przypisanie automatycznie: tag, kod −5%, ceny
        busy(T("przypisujemy_plan_do_konta", "Przypisujemy plan do Twojego konta…"), T("odblokowujemy_ceny", "Odblokowujemy ceny i Twój kod −5%."));
        api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (f) {
          if (f && f.success && f.plan) {
            state.plan = f.plan; state.code = f.discount_code || null;
            renderFull(f.plan, state.code); show(9);
          } else { renderTeaser(r.plan); show(9); }
        }).catch(function () { renderTeaser(r.plan); show(9); });
      }
      else { renderTeaser(r.plan); show(9); }
    }).catch(function () { show("empty"); });
  }

  // ── start ──
  function init() {
    normalizeState();
    var qs = new URLSearchParams(location.search);
    if (CFG.mode === "view") {
      var pid = qs.get("plan") || CFG.metaPlanId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
      loadLocal();
      if (pid && /^[0-9a-f-]{36}$/.test(pid)) { viewFlow(pid); return; }
      // zalogowana bez linku/metafielda (inne urządzenie) — znajdź plan po e-mailu konta
      if (CFG.logged && CFG.email) {
        busy("Szukamy Twojego planu…", "");
        api({ action: "my_plan", email: CFG.email, website: "" }).then(function (r) {
          if (r && r.success && r.plan_id) viewFlow(r.plan_id); else show("empty");
        }).catch(function () { show("empty"); });
        return;
      }
      show("empty");
      return;
    }
    // tryb dobor
    if (CFG.logged && CFG.email) {
      state.email = CFG.email;
      var ef = el("jdbEmailField"); if (ef) { ef.value = CFG.email; ef.readOnly = true; }
      jdbCheckPlanGate();
    }
    if (qs.get("krok") === "final") { loadLocal(); if (CFG.logged && CFG.email) { finalizeFlow(); } else { show(10); } return; }
    if (root.querySelector(".form-errors")) { loadLocal(); show(10); return; }
    // zalogowana bez uprawnień, ale z niedokończonym planem (rejestracja poza flow,
    // np. przez panel konta Shopify) — dokończ przypisanie w tle i odśwież ceny
    if (CFG.logged && CFG.email && !CFG.pro) {
      var autoDone = false;
      try { autoDone = sessionStorage.getItem("jdb_autofin") === "1"; } catch (e) {}
      if (!autoDone) {
        var markDone = function () { try { sessionStorage.setItem("jdb_autofin", "1"); } catch (e) {} };
        var autoFin = function (pid) {
          api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (r) {
            markDone();
            if (r && r.success) location.reload();
          }).catch(function () {});
        };
        // najpierw plan powiązany z e-mailem konta (my_plan); localStorage tylko jako
        // rezerwa (formularz bez e-maila) — na wspólnym komputerze może być cudzy/stary
        api({ action: "my_plan", email: CFG.email, website: "" }).then(function (r) {
          if (r && r.success && r.plan_id) { autoFin(r.plan_id); return; }
          var lpid = CFG.metaPlanId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
          if (lpid && /^[0-9a-f-]{36}$/.test(lpid)) { autoFin(lpid); } else { markDone(); }
        }).catch(function () {});
      }
    }
    show(0);
  }

  window.jdbGoLogin = function () {
    saveLocal();
    // Nowe konta Shopify nie wracają na return_url — logowanie w nowej karcie,
    // a tu zostaje przycisk „Zalogowałam się — pokaż mój plan".
    var url = JAD_ROOT + "account/login?return_url=" + encodeURIComponent((CFG.pageUrl || "/pages/dobor-pielegnacji") + "?krok=final");
    var w = window.open(url, "_blank");
    if (!w) { location.href = url; return; }
    var btn = el("jdbRegBtn"); if (btn) btn.style.display = "none";
    var after = el("jdbAfterLogin"); if (after) after.style.display = "block";
  };

  init();
})();
